import { AuthModel } from './auth.model';
import { AddressModel } from './address.model';
import { SocialNetworksModel } from './social-networks.model';

export class UserLoginModel extends AuthModel {
  IdVinculo: number;
  IdEsAdministrador: number;
  NombreCompleto: string;
  Usuario: string;
  Vinculo: string;
  NombreI: string;;
  NombreII: string;;
  ApellidoI: string;;
  ApellidoII: string;;
  Cedula: string;
  ActividadEconomica: string;
  Sexo: string;
  EstadoCivil: string;;
  FechaNacimiento: Date;
};

export class NewUserModel extends AuthModel {
  "Nombre": string;
  "Apellido": string;
  "Email": string;
  "Identificacion": string;
  "IdTipoDocumento": number;
  "Clave": string;
  "CodCorredor": string;
  "IdEsAdministrador" : number;

  setNewUser(user: any) {
    this.Nombre = user.firstname;
    this.Apellido = user.lastname;
    this.Email = user.Email;
    this.IdTipoDocumento = user.documentType;
    this.Identificacion = user.document;
    this.Clave = user.password;
    this.CodCorredor = user.codCorredor;
    this.IdEsAdministrador = user.IdEsAdministrador
  }
};

export class UserModel extends AuthModel {
  id: string;
  isAdmin: number;
  role: number;
  vinculo: string;
  username: string;
  password: string;
  Usuario: string;
  Clave: string;
  fullname: string;
  email: string;
  Email: string;
  pic: string;
  roles: number[];
  occupation: string;
  companyName: string;
  phone: string;
  address?: AddressModel;
  socialNetworks?: SocialNetworksModel;
  cedula: string;
  // personal information
  firstname: string;
  lastname: string;
  website: string;
  // account information
  language: string;
  timeZone: string;
  communication: {
    email: boolean,
    sms: boolean,
    phone: boolean
  };
  // email settings
  emailSettings: {
    emailNotification: boolean,
    sendCopyToPersonalEmail: boolean,
    activityRelatesEmail: {
      youHaveNewNotifications: boolean,
      youAreSentADirectMessage: boolean,
      someoneAddsYouAsAsAConnection: boolean,
      uponNewOrder: boolean,
      newMembershipApproval: boolean,
      memberRegistration: boolean
    },
    updatesFromKeenthemes: {
      newsAboutKeenthemesProductsAndFeatureUpdates: boolean,
      tipsOnGettingMoreOutOfKeen: boolean,
      thingsYouMissedSindeYouLastLoggedIntoKeen: boolean,
      newsAboutMetronicOnPartnerProductsAndOtherServices: boolean,
      tipsOnMetronicBusinessProducts: boolean
    }
  };

  setUser(user: any) {
    this.id = user.id;
    this.isAdmin = user.isAdmin || 0
    this.role = user.role;
    this.username = user.username || '';
    this.password = user.password || '';
    this.fullname = user.fullname || '';
    this.email = user.email || '';
    this.Email = user.Email || '';
    this.pic = user.pic || './assets/media/users/default.jpg';
    this.roles = user.roles || [];
    this.occupation = user.occupation || '';
    this.companyName = user.companyName || '';
    this.phone = user.phone || '';
    this.address = user.address;
    this.socialNetworks = user.socialNetworks;
    this.cedula = user.cedula;
  }


}
